import styles from './LoadingOverlay.module.css';
import { KatSpinner } from '@amzn/katal-react';

interface LoadingOverlayProps {
  /**
   * The text to display below the spinner
   */
  text: string;

  /**
   * Whether the overlay should cover the entire screen
   * Defaults to true, which means it will cover the full screen.
   */
  fullScreen?: boolean;
}

/**
 * A full-screen loading overlay component that displays a centered KatSpinner
 * with customizable text below it.
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ text, fullScreen = true }) => {
  return (
    <div className={fullScreen ? styles.fullScreenContainer : styles.localContainer}>
      <div className={styles.content} role="status" aria-live="polite">
        <KatSpinner size="large" data-testid="loading-spinner" />
        <div className={styles.text}>{text}</div>
      </div>
    </div>
  );
};
